export const PANEL_FILTER_OPTIONS = [
  {
    key: "active",
    translationKey: "sidebar.panels.faultStatuses.active",
    faultStatus: "ACTIVE",
  },
  {
    key: "tracking",
    translationKey: "sidebar.panels.faultStatuses.tracking",
    faultStatus: "OBSERVATION",
  },
  {
    key: "solved",
    translationKey: "sidebar.panels.faultStatuses.solved",
    faultStatus: "SOLVED",
  },
];

export const PANEL_SORTING_OPTIONS = [
  {
    key: "newest",
    translationKey: "sidebar.filters.sortBy.newest",
    sortFunction: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  },
  {
    key: "oldest",
    translationKey: "sidebar.filters.sortBy.oldest",
    sortFunction: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  },
  {
    key: "asc",
    translationKey: "sidebar.filters.sortBy.asc",
    sortFunction: (a, b) => a.name.localeCompare(b.name),
  },
  {
    key: "desc",
    translationKey: "sidebar.filters.sortBy.desc",
    sortFunction: (a, b) => b.name.localeCompare(a.name),
  },
];

export const STATUS_OPTIONS = [
  { key: "ACTIVE", translationKey: "sidebar.panels.faultStatuses.active" },
  {
    key: "OBSERVATION",
    translationKey: "sidebar.panels.faultStatuses.tracking",
  },
  { key: "SOLVED", translationKey: "sidebar.panels.faultStatuses.solved" },
];
